class DialogUtil {
  /**
   * Shows custom error alert or dialog box, with a title of 'Error' and button name of 'Ok'. When not running through Cordova, a normal browser alert is shown.
   * @param {String} message - The text to put in the dialog's body.
   */
  static errorAlert (message) {
    window.alert(message)
  }

  /**
   * Shows confirmation dialog box (multiple buttons can be used). When not running through Cordova, a normal browser confirm is shown.
   * @param {String} message - The text to put in the dialog's body.
   * @returns {Promise<(Number|Boolean)>} - If not running through Cordova, 'true' is returned when the Ok button is clicked, on Cordova the one-based index of the button that was clicked is returned or 0 if dismissed.
   */
  static async confirm (message) {
    return new Promise(async (resolve, reject) => {
      const confirmResult = window.confirm(message)
      resolve(confirmResult)
    })
  }
}

export default DialogUtil
